import { render, staticRenderFns } from "./addPerson.vue?vue&type=template&id=2bef9d2f&scoped=true"
import script from "./addPerson.vue?vue&type=script&lang=js"
export * from "./addPerson.vue?vue&type=script&lang=js"
import style0 from "./addPerson.vue?vue&type=style&index=0&id=2bef9d2f&prod&lang=scss&scoped=true"
import style1 from "./addPerson.vue?vue&type=style&index=1&id=2bef9d2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef9d2f",
  null
  
)

export default component.exports